<template lang="pug">
.content-center.highlight
  .overlay
  .back-btn(@click="back()")
    i.fa-solid.fa-left-long
    |  {{ $t("ui.back") }}
  .tab-nav
    ul.scrolling-wrapper
      li
        a(href='javascript:void(0);' @click="setMode(1)" :class="{'active': mode == 1}") {{ $t("ui.highlight") }}
      li
        a(href='javascript:void(0);' @click="setMode(0)" :class="{'active': mode == 0}") {{ $t("ui.live") }}  
          span.badge.bg-warning.text-dark(v-if="this.liveTV.count") {{ this.liveTV.count }}
  template(v-if="mode == 1")
    .tab-nav2
      ul
        li
          a(href="javascript:void(0);" :class="{ 'active': selectedDate == null }" @click="setDated()") {{ $t("ui.all") }}
        li(v-for="item in mondays" @click="setDated(item)")
          a(href='javascript:void(0);' :class="{ 'active': selectedDate == item }") {{ $dayjs(item).format('MM/DD') }} - {{ $dayjs(item).add(6, 'days').format('MM/DD') }}
    .league-group
      .scrolling-wrapper
        .league-card(:class="{ 'active': selectedHighlightLeague == null }" @click="setHighlightLeague()")
          img.icon(src='images/league-logo/all.png' alt='')
          span {{ $t("ui.all") }}
        .league-card(v-for="item in highlightLeague" :class="{ 'active': selectedHighlightLeague == item.league_id }" @click="setHighlightLeague(item.league_id)")
          img.icon(v-if="item.league_logo_path" :src="item.league_logo_path")
          span {{ getName('name_', item) }}
    .highlight-wrapper      
      template(v-if="loading.list")
        loading
      template(v-else-if="list.length > 0")
        template(v-for="(x, index) in list") 
          .highlight-video-group 
            .highlight-video(v-if="isPlay(x.match_id)")
              .highlight-video-live
                player(:src="x.video_link", @add="addPlayer", @remove="removePlayer", @play="playing")
            .highlight-video(v-else)
              .overlay
                .icon(@click="play(x.match_id)")
                  i.far.fa-play-circle
              .header-league
                .league
                  img.league-icon(v-if="x.league_logo_path" :src='x.league_logo_path')
                  span {{ getName('name_', x) }}
              .highlight-match-info
                .league-logo
                  img(v-if="x.league_logo_path" :src='x.league_logo_path')
                .match-box
                  .date-wrap
                    .date
                      i.fa-solid.fa-calendar
                      |  {{ $dayjs(x.match_time).format('MM/DD') }} {{ $dayjs(x.match_time).format('h:mmA') }}
                    .ht-score
                      | HT 
                      span {{ x.half_home }} : {{ x.half_away }}
                  .team-group
                    .team
                      .team-logo
                        img(v-if="x.home_logo_path" :src='x.home_logo_path')
                        img(v-else src='images/team-logo/home-team.png')
                      .team-home H
                      .team-name {{ getName('home_name_', x) }}
                    .score-box {{ x.final_home }}
                  .team-group
                    .team.mb-0
                      .team-logo
                        img(v-if="x.away_logo_path" :src='x.away_logo_path')
                        img(v-else src='images/team-logo/away-team.png')
                      .team-away A
                      .team-name {{ getName('away_name_', x) }}
                    .score-box {{ x.final_away }}
              .highlight-video-live
                //tv-bg-basketball
                //tv-bg-epl
                //tv-bg-germany
                //tv-bg-italy
                //tv-bg-others
                //tv-bg-spain
                //tv-bg-uefac
                //tv-bg-uefae
                //tv-bg-worldcup
                img(:src='getLeagueBG(x)')
              //- .highlight-play
              //-   a(href='javascript:void(0);' @click="play(x.match_id)")
              //-     img(src='images/highlight/play_icon.svg')
      template(v-else)
        .message-empty
          .empty.text-center.mt-5
            img.no-info(src='images/empty-icon.png' alt='')
          p.no-message.text-center {{ $t("message.no_information_available") }}
  template(v-else)
    template(v-if="liveTV.loading") 
      loading
    template(v-else-if="this.liveTV.count > 0")
      .category-group
        .scrolling-wrapper
          .category(:class="{ 'active': selectedLiveNow === '0' }" @click="setLiveNow('0')")
            .sport-name {{ $t("ui.all") }}
            .event-count {{ this.liveTV.count }}
          .category(v-for="item in liveSportsList" :key="item" :class="{ 'active': selectedLiveNow === item }" @click="setLiveNow(item)")
            .sport-icon.inactive
              img(:src="'images/light/sport/blue/' + item + '.svg'")
            .sport-icon.active
              img(:src="'images/light/sport/white/' + item + '.svg'") 
            .sport-name {{ sports[item] }}
            .event-count(v-if="liveTV.schedule") {{ liveTV.schedule[item].length }}
      .highlight-wrapper
        template(v-if="liveTV.filtering")
          loading
        template(v-else)
          template(v-for="(group, index, count) in highlightList")
            template(v-for="(item, index) in group")
              .card
                .m-card-header(:id="'livenow-' + item.league_id + index" data-bs-toggle='collapse' :data-bs-target="'#livenow-' + item.match_id" aria-expanded='true' :aria-controls="'livenow-' + item.match_id")
                  .group
                    .icon.inactive
                      img(:src="'images/light/sport/blue/' + item.sports_type + '.svg'" alt='')
                    .icon.active
                      img(:src="'images/light/sport/white/' + item.sports_type + '.svg'" alt='')
                    .league-name {{ item.home_name_en }} VS {{ item.away_name_en }}
                  .pulse
                .video-group(:id="'livenow-' + item.match_id" :aria-labelledby="'livenow-' + item.league_id + index" :aria-controls="'livenow-' + item.match_id")
                  .highlight-video-wrapper
                    .highlight-video-group
                      .highlight-video.mt-0
                        template(v-if="event.match_id != item.match_id")
                          .highlight-match-info
                            .match-box
                              .team-group
                                .team
                                  .team-logo
                                    img(v-if="item.home_logo_path" :src="item.home_logo")
                                    img(v-else src='images/team-logo/home-team.png')
                                  .team-home H
                                  .team-name {{ item.home_name_en }}
                              .team-group
                                .team.mb-0
                                  .team-logo
                                    img(v-if="item.away_logo_path" :src="item.away_logo")
                                    img(v-else src='images/team-logo/away-team.png')
                                  .team-away A
                                  .team-name {{ item.away_name_en }}
                          .highlight-video-live
                            img(src='images/highlight/live-tv-bg.jpg')
                          .highlight-play
                            a(href='javascript:void(0);' @click="chooseMatch(item)")
                              img(src='images/highlight/play_icon.svg')
                        template(v-else)
                          .highlight-match-info
                            i.fa.fa-spinner.fa-spin(v-if="loader")
                            span(v-if="error") {{ error == 'Match Not Started' ? "" : error }}
                          .highlight-video-live
                            img(src='images/highlight/live-tv-bg.jpg')
                            .widget(:id="'widget-' + item.match_id")
                    .btn-view-odd(@click="handleMore(item)") {{ $t("ui.view_odds") }}    
    template(v-else)
      .message-empty
        .empty.text-center.mt-5
          img.no-info(src='images/empty-icon.png' alt='')
        p.no-message.text-center {{ $t("message.no_information_available") }}
            
</template>


<script>
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-game.js";
import mixinExt from "@/library/mixinExt.js";
import mixinMain from "@/library/mixinMain.js";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/library/_xhr-ext";
import player from "@/components/mobile/highlight/player";

import loading from "@/components/ui/loading";

export default {
  components: {
    player,
    loading
  },
  mixins: [mixinExt, mixinMain],
  data() {
    return {
      mode: 1,
      event: {
        action: null,
        radar_id: null,
        channel: null,
        match_id: null,
        sport_id: null,
        market_type: null,
        home_team: null,
        away_team: null,
        working_date: null,
        match_time: null,
        next: null,
        prev: null
      },
      error: null,
      url: "",
      embedded: false,
      liveTV: {
        schedule: [],
        loading: false,
        filtering: false,
        count: 0,
        matches: {}
      },
      loader: false,
      highlightLeague: [],
      list: [],
      player: [],
      loading: {
        league: false,
        list: false
      },
      vid: "",
      selectedDate: null,
      selectedHighlightLeague: null,
      selectedLiveNow: "0",
      mondays: [],
      liveSportsList: [],
      highlightList: [],
      isPlayMatchId: null
    };
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel === "1";
    },
    language() {
      return this.$store.getters.language;
    },
    newFeatures() {
      return config.newFeatures;
    },
    vg1() {
      return config.vg1;
    },
  },
  destroyed() {
    EventBus.$off("LIVE_CENTER", this.handleLiveCenter);
    clearInterval(this.getSchedule);
    this.stopAllVideos();
  },
  mounted() {
    EventBus.$on("LIVE_CENTER", this.handleLiveCenter);
    this.setMode(1);
    var d = new Date(),
      td = new Date(),
      mondays = [];

    d.setDate(1);
    d.setMonth(d.getMonth() - 2);

    // Get the first Monday in the month
    while (d.getDay() !== 1) {
      d.setDate(d.getDate() + 1);
    }

    // Get all the other Mondays in the month
    while (d < td) {
      var pushDate = new Date(d.getTime());
      mondays.push(pushDate);
      d.setDate(d.getDate() + 7);
    }

    this.mondays = mondays.reverse();
  },
  methods: {
    back() {
      this.$router.push("/lobby");
    },
    isPlay(e) {
      return this.isPlayMatchId === e;
    },
    play(e) {
      this.isPlayMatchId = e;
    },
    setDated(e) {
      this.stopAllVideos();
      this.selectedDate = e;
      this.getList();
    },
    setHighlightLeague(e) {
      this.stopAllVideos();
      this.selectedHighlightLeague = e;
      this.getList();
    },
    setLiveNow(e) {
      this.selectedLiveNow = e;
      this.closeWidget();
      this.clearWidget();
      this.getSchedule();
    },
    clearWidget() {
      if (this.vid) {
        $("#widget-" + this.vid).html("");
      }
    },
    handleLiveCenter(e) {
      this.stopAllVideos();
      this.event = e;
      this.error = null;
      this.embedded = false;
      this.mode = 0;
      this.setChannel();
    },
    chooseMatch(e) {
      this.stopAllVideos();
      this.clearWidget();
      this.vid = e.match_id;
      EventBus.$emit("LIVE_CENTER", {
        action: "channel",
        radar_id: e.radar_id,
        channel: e.channel,
        match_id: e.match_id,
        league_id: e.league_id,
        sport_id: e.sports_type,
        market_type: e.market_type,
        home_team: e.home_name_en,
        away_team: e.away_name_en,
        working_date: e.working_date,
        match_time: e.match_time
      });
    },
    setChannel() {
      var q = this.event;
      if (q.channel === null) {
        this.error = "Please select a channel to watch...";
      } else if (q.channel === "1") {
        this.launchLiveTV(q.channel, q.match_id, q.sport_id, "1.1.1.1");
      } else {
        this.getVersion(q).then(
          res => {
            this.launchLiveTV(q.channel, q.match_id, q.sport_id, res);
          },
          err => {
            this.error = err;
          }
        );
      }
    },
    setMode(e) {
      if (this.mode !== e) {
        if (e === 0) {
          this.stopAllVideos();
        } else {
          this.closeWidget();
          this.clearWidget();
        }
      }
      this.mode = e;
      switch (e) {
        case 0:
          this.getSchedule();
          break;
        case 1:
          this.getLeague();
          this.getList();
          break;
      }
    },
    getSchedule(callback) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken
      };

      var isInitialLoad = this.liveTV.loading !== true && this.liveTV.count === 0;
      var isFiltering = this.liveTV.count > 0 && this.liveTV.filtering !== true;
      
      if (isInitialLoad) {
        this.liveTV.loading = true;
      } else if (isFiltering) {
        this.liveTV.filtering = true;
      } else if (this.liveTV.loading === true || this.liveTV.filtering === true) {
        return;
      }
      
      service.getLiveList(config.liveTvListUrl(), json).then(
        result => {
          this.liveTV.loading = false;
          this.liveTV.filtering = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success === true) {
              var data = [];
              for (var n = 0; n < result.data.length; n++) {
                if (!this.vg1.includes(result.data[n].sports_type)) {
                  data.push(result.data[n]);
                }
              }

              this.liveTV.count = data.length;
              var group = data.reduce((r, a) => {
                r[a.sports_type] = [...(r[a.sports_type] || []), a];
                return r;
              }, {});
              var gk = Object.keys(group);
              for (var i = 0; i < gk.length; i++) {
                group[gk[i]].sort((a, b) => {
                  var keyA = new Date(a.match_time),
                    keyB = new Date(b.match_time);
                  if (keyA < keyB) return -1;
                  if (keyA > keyB) return 1;
                });
              }
              this.liveTV.schedule = group;
              this.liveSportsList = gk;
              var regroup = Object.keys(group).filter(key => {
                return (this.selectedLiveNow !== "0") ? key === this.selectedLiveNow : key;
              }).reduce((obj, key) => {
                obj[key] = group[key];
                return obj;
              }, {});
              this.highlightList = regroup;

              if (callback) {
                callback(data);
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.liveTV.loading = false;
          this.liveTV.filtering = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    setWidget(e) {
      if (this.vid) {
        $("#widget-" + this.vid).html(e);
      }
    },
    closeWidget() {
      this.clearWidget();
      this.event = {
        action: null,
        radar_id: null,
        channel: null,
        match_id: null,
        sport_id: null,
        market_type: null,
        home_team: null,
        away_team: null,
        working_date: null,
        match_time: null,
        next: null,
        prev: null
      };
      this.error = "";
      this.url = "";
      this.embedded = false;
      this.vid = "";
    },
    tvLink(e) {
      if (config.vg1.includes(e)) {
        return config.player10Url();
      } else {
        return config.bintuUrl();
      }
    },
    launchLiveTV(ch, mc, sp, ip) {
      var args = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        channel: ch,
        match: mc,
        sports: sp,
        ip: ip,
        brand: config.brand,
      };
      this.loader = true;
      this.error = "";
      xhr.launchLiveTV(args).then(
        res => {
          this.loader = false;
          if (res) {
            if (res.success === true) {
              this.url = res.data;
              this.embedded = this.url.includes("<iframe");
              if (!this.embedded) {
                this.embedded = this.url.includes("<script");
              }

              if (!this.embedded) {
                if (ch != 1) {
                  var link = this.url + "&compact=1";
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  this.setWidget(html);
                } else {
                  var link = this.tvLink(sp) + this.url + "&u=" + args.account_id + "&t=" + args.session_token + "&product=" + sp;
                  var html = '<iframe src="' + link + '" frameborder="0" allowfullscreen="true" scrolling="no">';
                  // console.log(html)
                  this.setWidget(html);
                }
              } else {
                var kns = this.url.replace("www.example.com", window.location.hostname);
                this.setWidget(kns);
              }
            } else {
              this.error = this.$t("error." + res.status);
            }
          }
        },
        err => {
          this.loader = false;
          this.error = this.$t("error." + err.status);
        }
      );
    },
    getVersion() {
      const url = "https://api.ipify88.com/";
      return new Promise((resolve, reject) => {
        this.$http.get(url).then(
          res => {
            resolve(res.bodyText);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    handleMore(source) {
      var mi5 = {
        menuX: false,
        menuY: "0",
        menu1: "live",
        menu3: "hdpou",
        menu0: "live",
        menu2: parseInt(source.sports_type)
      };
      this.$store.dispatch("layout/setMenuItems", mi5);
      this.$store.dispatch("layout/setSelectedMatch", source.match_id);
      EventBus.$emit("GET_MATCH2");
      this.$router.push("/more").catch(err => {});
    },
    getName(p, e) {
      var name = e[p + this.language];
      if (name === null || name === "" || !name) {
        name = e[p + "en"];
      }
      return name;
    },
    playing(e) {
      var i = this.player.indexOf(e);
      for (var j = 0; j < this.player.length; j++) {
        if (j != i && this.player[j] && typeof this.player[j].pause === 'function') {
          try {
            this.player[j].pause();
          } catch (err) {
            console.error('Error pausing player:', err);
          }
        }
      }
    },
    addPlayer(e) {
      if (this.player.indexOf(e) < 0) {
        this.player.push(e);
      }
    },
    removePlayer(e) {
      var i = this.player.indexOf(e);
      if (i > -1) {
        this.player.splice(i, 1);
      }
    },
    stopAllVideos() {
      // Pause all active players
      for (var i = 0; i < this.player.length; i++) {
        if (this.player[i] && typeof this.player[i].pause === 'function') {
          try {
            this.player[i].pause();
          } catch (err) {
            console.error('Error pausing player:', err);
          }
        }
      }
      // Reset the playing match ID to destroy the player component
      this.isPlayMatchId = null;
      // Clear the player array
      this.player = [];
    },
    getLeague() {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
      };
      this.loading.league = true;
      service.getAnyList(config.highlightLeagueUrl(), json).then(
        (result) => {
          this.loading.league = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              var data = result.data;
              if (data != null && data.length > 0) {
                this.highlightLeague = data;
              } else {
                this.highlightLeague = [];
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        (err) => {
          this.loading.league = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getList() {
      var league_id = null;
      var match_date = null;

      if (this.highlightLeague.length > 0) {
        if (this.selectedHighlightLeague) {
          league_id = this.selectedHighlightLeague;
        }

        if (this.selectedDate) {
          match_date = this.$dayjs(this.selectedDate).format("YYYY-MM-DD");
        }
      }

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        league_id: league_id,
        match_date: match_date,
        page_number: 1,
        page_size: 500,
      };
      this.loading.list = true;
      this.list = [];
      service.getAnyList(config.highlightListUrl(), json).then(
        (result) => {
          this.loading.list = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              var data = result.data;
              if (data != null && data.length > 0) {
                this.list = data;
              } else {
                this.list = [];
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        (err) => {
          this.loading.list = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getLeagueBG(e) {
      // getName('name_', item)
      // tv-bg-epl
      // tv-bg-germany
      // tv-bg-italy
      // tv-bg-others
      // tv-bg-spain
      // tv-bg-uefac
      // tv-bg-uefae
      // tv-bg-worldcup
      var leagueName = this.getName('name_', e);
      switch (leagueName) {
        case "NBA":
        case "NBA (PLAYOFF)":
        case "NBA (FINAL)":
          return "images/highlight/tv-bg/tv-bg-basketball.jpg";
        case "ENGLISH PREMIER LEAGUE":
          return "images/highlight/tv-bg/tv-bg-epl.jpg";
        case "GERMANY-BUNDESLIGA I":
          return "images/highlight/tv-bg/tv-bg-germany.jpg";
        case "ITALY SERIE A":
          return "images/highlight/tv-bg/tv-bg-italy.jpg";
        case "SPAIN PRIMERA LALIGA":
          return "images/highlight/tv-bg/tv-bg-spain.jpg";
        case "UEFA CHAMPIONS LEAGUE":
          return "images/highlight/tv-bg/tv-bg-uefac.jpg";
        case "UEFA EUROPA LEAGUE":
          return "images/highlight/tv-bg/tv-bg-uefae.jpg";
        case "WORLD CUP 2026 EUROPE QUALIFIERS":
          return "images/highlight/tv-bg/tv-bg-worldcup.jpg";
        default:
          return "images/highlight/tv-bg/tv-bg-others.jpg";
      }
    }
  }
};
</script>
